var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7807_12840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 14.6667C4.399 14.6667 4.14767 14.5623 3.95933 14.3733L0.293 10.707C0.104333 10.519 0 10.2677 0 10C0 9.73233 0.104333 9.481 0.293333 9.29266L3.95967 5.62633C4.14767 5.43766 4.399 5.33333 4.66667 5.33333C5.218 5.33333 5.66667 5.78199 5.66667 6.33333C5.66667 6.60099 5.56233 6.85233 5.37333 7.04066L2.414 10L5.37367 12.9597C5.56267 13.1477 5.66667 13.399 5.66667 13.6667C5.66667 14.218 5.218 14.6667 4.66667 14.6667Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 15C14.782 15 14.3333 14.5513 14.3333 14C14.3333 13.7323 14.4376 13.481 14.6266 13.2927L17.586 10.3333L14.6263 7.37366C14.4376 7.18499 14.3333 6.93366 14.3333 6.66666C14.3333 6.11532 14.782 5.66666 15.3333 5.66666C15.601 5.66666 15.8523 5.77099 16.0406 5.95999L19.707 9.62632C19.896 9.81499 20 10.0663 20 10.3333C20 10.601 19.8956 10.8523 19.7066 11.0407L16.0403 14.707C15.8523 14.896 15.601 15 15.3333 15Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17.6667C6.44867 17.6667 6 17.218 6 16.6667C6 16.534 6.026 16.4043 6.07667 16.2817L12.077 2.94766C12.2337 2.57433 12.596 2.33333 13 2.33333C13.5513 2.33333 14 2.78199 14 3.33333C14 3.46599 13.974 3.59566 13.9233 3.71833L7.923 17.0523C7.76633 17.4257 7.404 17.6667 7 17.6667Z",
    fill: "#171717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7807_12840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopersIcon);
export default __webpack_public_path__ + "static/media/developersIcon.7237adb8be36ec50a3f2a3e2af667786.svg";
export { ForwardRef as ReactComponent };